import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    changeLog: {
        marginLeft: theme.spacing(2),
    },
}));
